import React from 'react'
import ReactDOM from 'react-dom/client'
import { SnackbarProvider } from 'notistack';
import App from './App.jsx'
import './index.css'
import {store} from './store'
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import global_es from './translations/es/global.json';
import global_en from './translations/en/global.json';

import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  breakpoints: {
    values: {
      sxs: 0,         // Celular vertical super pequeño
      xs: 380,        // Celular vertical (iphone, samsung)
      sm: 460,        // Ipad o tablet vertical
      md: 1025,       // Ipad o tablet horizontal
      lg: 1900,       // Laptop
      xl: 3000,       // Laptop o PC con super resolución
    },
  },
  palette: {
    secondary: {
      //main: '#f44336', // Código HEX para rojo estándar de Material-UI
      main: '#B91215'
      // También puedes usar:
      // main: 'red', // Nombre del color CSS
      // O definir tus propios valores RGB/rgba
    },
  },
});

i18next.init({
    interpolation: { escapeValue: false },
    lng: (window.localStorage.getItem("dl-lang") ? window.localStorage.getItem("dl-lang") : "es" ),
    resources: {
        es: {
            global: global_es
        },
        en: {
            global: global_en
        }
    }
})

ReactDOM.createRoot(document.getElementById('root')).render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,

    // <I18nextProvider i18n={i18next}>
    //     <Provider store={store}>
            <ThemeProvider theme={theme}>
                <SnackbarProvider maxSnack={3} autoHideDuration={6000} preventDuplicate={true} >
                    <App />
                </SnackbarProvider>
            </ThemeProvider>
    //     </Provider>
    // </I18nextProvider>
)
